module.exports = __webpack_public_path__ + "img/paypal_credit.8e33dc63.png";